module.exports = __webpack_public_path__ + "static/img/1.eea2cf8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/t-carousel/1.jpg
// module id = U+j5
// module chunks = 1